import { render, staticRenderFns } from "./invoice-list.vue?vue&type=template&id=166d2b67&"
import script from "./invoice-list.vue?vue&type=script&lang=js&"
export * from "./invoice-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports